import React from "react";
import { Dropdown } from "semantic-ui-react";
import { useStyles } from "./style";

const DropdownMentor = ({
  handleChange,
  list,
  value,
  placeholder = "Select Student",
}) => {
  const classes = useStyles();

  return (
    <Dropdown
      placeholder={placeholder}
      onChange={(e, data) => handleChange(e, data)}
      fluid
      search
      selection
      options={list}
      value={value}
      className={classes.dropdown}
    ></Dropdown>
  );
};

export default DropdownMentor;
